import React, { useState, useEffect } from 'react';
import axios from 'axios';
import colors from "../Constant/colors";
import { HiTrash } from "react-icons/hi";
import { BiBriefcase, BiBook, BiMap, BiUser } from "react-icons/bi";
import { MdDescription } from "react-icons/md";

const CurrentOpenings = () => {
  const [openings, setOpenings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobOpenings = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/job-openings`);
        setOpenings(response.data);
      } catch (error) {
        setError('Error fetching job openings');
      } finally {
        setLoading(false);
      }
    };
    fetchJobOpenings();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(` ${process.env.REACT_APP_API_BASE_URL}/api/job-openings/${id}`,
        { headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }
      );
      setOpenings(openings.filter((opening) => opening._id !== id));
    } catch (error) {
      setError('Error deleting job opening');
    }
  };

  if (loading) return <div className="text-center mt-20">Loading...</div>;
  if (error) return <div className="text-center mt-20 text-red-600">{error}</div>;

  return (
    <div className="min-h-screen p-6 bg-gray-50 flex justify-center">
      <div className="w-full max-w-7xl bg-white shadow-md rounded-xl p-8">
        
      
        <p className="text-gray-600 mb-8 text-[15px]">
          View, manage & remove available job opportunities.
        </p>

        {/* LEDGER TABLE */}
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300 rounded-xl">
            <thead className="bg-blue-50 border-b">
              <tr>
                {["Job Title", "Description", "Education", "Experience", "Job Type", "Location", "Actions"].map((head) => (
                  <th
                    key={head}
                    className="py-3 px-5 text-left text-[15px] font-semibold text-gray-700 tracking-wide"
                  >
                    {head}
                  </th>
                ))}
              </tr>
            </thead>
<tbody>
  {openings.map((opening, i) => (
    <tr
      key={opening._id}
      className={`transition ${
        i % 2 === 0 ? "bg-white" : "bg-gray-50"
      } hover:bg-blue-50`}
    >
      <td className="py-3 px-5 text-[14px] text-gray-800">
        <div className="inline-flex items-center gap-2">
          <BiUser className="text-blue-600" /> {opening.jobTitle}
        </div>
      </td>

      <td className="py-3 px-5 text-[14px] text-gray-800">
        <div className="inline-flex items-center gap-2">
          <MdDescription className="text-blue-600" /> {opening.jobDescription}
        </div>
      </td>

      <td className="py-3 px-5 text-[14px] text-gray-800">
        <div className="inline-flex items-center gap-2">
          <BiBook className="text-blue-600" /> {opening.education}
        </div>
      </td>

      <td className="py-3 px-5 text-[14px] text-gray-800">
        <div className="inline-flex items-center gap-2">
          <BiBriefcase className="text-blue-600" /> {opening.experience}
        </div>
      </td>

      <td className="py-3 px-5 text-[14px] text-gray-800">
        {opening.jobType}
      </td>

      <td className="py-3 px-5 text-[14px] text-gray-800">
        <div className="inline-flex items-center gap-2">
          <BiMap className="text-blue-600" /> {opening.location}
        </div>
      </td>

      <td className="py-3 px-5">
        <button
          onClick={() => handleDelete(opening._id)}
          className="flex items-center gap-2 bg-red-500 hover:bg-red-600 
                     text-white px-4 py-2 rounded-lg text-[14px] shadow-sm transition"
        >
          <HiTrash size={18} />
          Delete
        </button>
      </td>
    </tr>
  ))}
</tbody>


          </table>
        </div>
      </div>
    </div>
  );
};

export default CurrentOpenings;
